import { render, staticRenderFns } from "./IosBookGoods.vue?vue&type=template&id=81219842&scoped=true"
import script from "./IosBookGoods.vue?vue&type=script&lang=js"
export * from "./IosBookGoods.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81219842",
  null
  
)

export default component.exports